import { Route, RouteProps, useHistory } from 'react-router-dom';
import { useAuth } from '~/contexts/AuthProvider';
import * as Sentry from '@sentry/react';
import constVars from '~/constants/constVars';
import React, { useEffect } from 'react';
import { Center, Loader } from '@qred/components-library';
import { accessToken, TOKEN } from '~/store/apis/utils/accessToken';
import posthog from 'posthog-js';
import { useAccount } from '~/hooks/useAccount';

interface AuthenticatedRouteProps extends RouteProps {}

const AuthenticatedRoute = (props: AuthenticatedRouteProps) => {
  const { isAuthenticated, isLoading, isLoggingOut } = useAuth();
  const { setMarket, init, isInitialized } = useAccount();
  const history = useHistory();

  // Handle authentication redirect for non-internal-prod environments
  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      !isLoggingOut &&
      import.meta.env.MODE !== 'internal-prod'
    ) {
      if (window.location.pathname !== constVars.ROUTE_DEFAULT) {
        sessionStorage.setItem(
          'returnTo',
          `${window.location.pathname}${window.location.search}`
        );
      }

      // Redirect to login page so users can select their market and login method
      history.push(`/${constVars.ROUTE_LOGIN}`);
    }
  }, [isLoading, isAuthenticated, isLoggingOut]);

  // Handle authentication redirect for non-internal-prod environments
  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      !isLoggingOut &&
      import.meta.env.MODE !== 'internal-prod'
    ) {
      if (window.location.pathname !== constVars.ROUTE_DEFAULT) {
        sessionStorage.setItem(
          'returnTo',
          `${window.location.pathname}${window.location.search}`
        );
      }

      // Redirect to login page so users can select their market and login method
      window.location.href = `/${constVars.ROUTE_LOGIN}`;
    }
  }, [isLoading, isAuthenticated, isLoggingOut]);

  useEffect(() => {
    if (isAuthenticated) {
      accessToken.getDecoded().then((decodedToken: any) => {
        const _market = decodedToken[TOKEN.MARKET];
        if (_market) {
          setMarket(_market);
        }

        const userCode = decodedToken[TOKEN.USER_CODE];

        if (userCode) {
          posthog.identify(userCode);
          Sentry.setUser({ id: userCode });
        }
      });

      init();
    }
  }, [isAuthenticated]);

  // Show loader while authenticating or initializing
  if (isLoading || !isAuthenticated || !isInitialized) {
    return (
      <Center pt="xxl">
        <Loader size={'xxl'} />
      </Center>
    );
  }

  return <Route {...props} />;
};

export default AuthenticatedRoute;
